/* eslint-disable import/no-anonymous-default-export */
import {
  Button,
  CalendarPicker,
  List,
  Popup,
  Tabs,
  Swiper,
  ActionSheet,
  Divider,
  Dialog,
} from "antd-mobile";
import dayjs from "dayjs";
import { useState, useRef } from "react";
import { DemoBlock } from "./demo-block";
import { SwiperRef } from "antd-mobile/es/components/swiper";
import "./demo-block.css";
import { Action } from "antd-mobile/es/components/action-sheet";

const defaultRange: [Date, Date] = [
  dayjs().toDate(),
  dayjs().add(2, "day").toDate(),
];

export default () => {
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <div>按钮</div>
      <Divider />
      <DemoDialog />
      <div style={{ height: "20px" }}></div>
      <ButtonSolid />
      <div style={{ height: "20px" }}></div>
      <ButtonRounded />
      <div style={{ height: "20px" }}></div>
      <ButtonOutline />
      <div style={{ height: "20px" }}></div>
      <PopupAntd></PopupAntd>
      <div style={{ height: "20px" }}></div>
      <Calendar />
      <div style={{ height: "20px" }}></div>
      <Tabss />
      <div style={{ height: "20px" }}></div>
      <WithCancelButtonAndDescription />
    </div>
  );
};

export const DemoDialog = () => {
  return (
    <Button
    block
    onClick={() => {
      Dialog.show({
        content: '人在天边月上明，风初紧，吹入画帘旌',
        closeOnAction: true,
        actions: [
          {
            key: 'online',
            text: '在线阅读',
          },
          {
            key: 'download',
            text: '下载文件',
            bold: true,
          },
          [
            {
              key: 'cancel',
              text: '取消',
              style: {
                color: "var(--adm-color-text)"
              }
            },
            {
              key: 'delete',
              text: '删除',
              style: {
                color: 'var(--adm-color-danger)'
              },
              danger: true,
            },
          ],
        ],
      })
    }}
  >
    自定义按钮
  </Button>
  );
};

export const ButtonSolid = () => {
  return (
    <Button color="primary" fill="solid">
      Solid
    </Button>
  );
};

export const ButtonRounded = () => {
  return (
    <Button block shape="rounded" color="primary">
      Rounded
    </Button>
  );
};
export const ButtonOutline = () => {
  return (
    <Button color="primary" fill="outline">
      Outline
    </Button>
  );
};

export const PopupAntd = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button
        onClick={() => {
          setVisible(true);
        }}
      >
        圆角的弹出层
      </Button>
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        bodyStyle={{
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          minHeight: "40vh",
        }}
      >
        {mockContent}
      </Popup>
    </>
  );
};

const mockContent = (
  <div style={{ padding: 20 }}>
    "这是一些测试文字这是一些测试文字这是一些测试文字这是一些测试文字这是一些测试文字这是一些测试文字"
  </div>
);

const Calendar = () => {
  const [val, setVal] = useState<[Date, Date] | null>(() => [
    dayjs().subtract(2, "day").toDate(),
    dayjs().add(2, "day").toDate(),
  ]);
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);

  const singleDate: Date = new Date("2023-06-03");

  return (
    <List header="日期选择">
      <List.Item
        onClick={() => {
          setVisible1(true);
        }}
      >
        选择单个日期
        <CalendarPicker
          visible={visible1}
          selectionMode="single"
          defaultValue={singleDate}
          onClose={() => setVisible1(false)}
          onMaskClick={() => setVisible1(false)}
        />
      </List.Item>
      <List.Item
        onClick={() => {
          setVisible2(true);
        }}
      >
        选择日期范围
        <CalendarPicker
          visible={visible2}
          defaultValue={defaultRange}
          selectionMode="range"
          onClose={() => setVisible2(false)}
          onMaskClick={() => setVisible2(false)}
          onChange={(val) => {
            console.log(val);
          }}
        />
      </List.Item>
      <List.Item
        onClick={() => {
          setVisible3(true);
        }}
      >
        受控日期选择
        <CalendarPicker
          visible={visible3}
          selectionMode="range"
          value={val}
          onClose={() => setVisible3(false)}
          onMaskClick={() => setVisible3(false)}
          onChange={(val) => {
            setVal(val);
          }}
        />
      </List.Item>
    </List>
  );
};

const tabItems = [
  { key: "fruits", title: "水果" },
  { key: "vegetables", title: "蔬菜" },
  { key: "animals", title: "动物" },
];

const Tabss = () => {
  const swiperRef = useRef<SwiperRef>(null);
  const [activeIndex, setActiveIndex] = useState(1);

  return (
    <>
      <DemoBlock title="配合 Swiper 实现手势滑动" padding="0">
        <Tabs
          activeKey={tabItems[activeIndex].key}
          onChange={(key) => {
            const index = tabItems.findIndex((item) => item.key === key);
            setActiveIndex(index);
            swiperRef.current?.swipeTo(index);
          }}
        >
          {tabItems.map((item) => (
            <Tabs.Tab title={item.title} key={item.key} />
          ))}
        </Tabs>
        <Swiper
          direction="horizontal"
          loop
          indicator={() => null}
          ref={swiperRef}
          defaultIndex={activeIndex}
          onIndexChange={(index) => {
            setActiveIndex(index);
          }}
        >
          <Swiper.Item>
            <div className={"content"}>菠萝</div>
          </Swiper.Item>
          <Swiper.Item>
            <div className={"content"}>西红柿</div>
          </Swiper.Item>
          <Swiper.Item>
            <div className={"content"}>蚂蚁</div>
          </Swiper.Item>
        </Swiper>
      </DemoBlock>
    </>
  );
};

const actions: Action[] = [
  {
    text: "复制",
    key: "copy",
    onClick: () => {
      window.alert("asdlfkj");
    },
  },
  { text: "修改", key: "edit" },
  { text: "保存", key: "save" },
];

function WithCancelButtonAndDescription() {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Button onClick={() => setVisible(true)}>取消按钮和额外描述</Button>
      <ActionSheet
        cancelText="取消"
        visible={visible}
        actions={actions}
        onClose={() => setVisible(false)}
      />
    </>
  );
}
